import { i18n } from "../translate/i18n";

// O erro de abrir o microfone é DOMException, não resposta HTTP: não tem
// `response.data.message`, então o toastError caía no "An error occurred!" e o
// atendente não sabia se era permissão, microfone ocupado ou falta de aparelho.
const CHAVES_POR_NOME = {
	NotAllowedError: "permissaoNegada",
	PermissionDeniedError: "permissaoNegada",
	SecurityError: "permissaoNegada",
	NotFoundError: "semMicrofone",
	DevicesNotFoundError: "semMicrofone",
	OverconstrainedError: "semMicrofone",
	NotReadableError: "microfoneEmUso",
	TrackStartError: "microfoneEmUso",
	AbortError: "microfoneEmUso",
};

// Gravar exige contexto seguro (https ou localhost); fora dele o navegador nem
// expõe o mediaDevices, e o erro cru seria um TypeError sem explicação.
export const microfoneDisponivel = () =>
	Boolean(navigator?.mediaDevices?.getUserMedia);

export const mensagemErroMicrofone = err => {
	const chave = CHAVES_POR_NOME[err?.name];
	if (chave) {
		return i18n.t(`messagesInput.audio.${chave}`);
	}

	const detalhe = err?.message || err?.name;
	const base = i18n.t("messagesInput.audio.falhaGravar");
	return detalhe ? `${base} — ${detalhe}` : base;
};
